import PhysiciansModal from './PhysiciansModal';

export default PhysiciansModal;
